export function isLpOnRightOf(playerIndex, lp, players){
    var leftIndex = players.map(p=>p.socketId).indexOf(lp.socketId) - 1;
    if(leftIndex < 0){
        leftIndex = players.length - 1;
    }

    return leftIndex == playerIndex;
}

export function leftPlayerOf(pl, players){
    var leftIndex =  players.map(p=>p.socketId).indexOf(pl.socketId) - 1;
    if(leftIndex < 0){
        leftIndex = players.length - 1;
    }

    return players[leftIndex];
}

export function rightPlayerOf(pl, players){
    if(!pl || !players){
        return null;
    }
    var rightIndex =  players.map(p=>p.socketId).indexOf(pl.socketId) + 1;
    if(rightIndex >= players.length){
        rightIndex = 0;
    }

    return players[rightIndex];
}

export function decRole(availableRoles, role){
    if(!role || !availableRoles){
        return availableRoles;
    }

    var result = [...availableRoles];
    const rIndex = result.map(r=>r.role.name).indexOf(role.name);
    if(rIndex >= 0){
        result[rIndex] = {
            role: result[rIndex].role,
            count: result[rIndex].count - 1
        };
        result = result.filter(r=>r.count > 0);
    }

    return result;
}